import { Application } from './models';

/**
 * The page a student belongs on, given the state of their application.
 *
 * A pure function of the application record: the resolver-turned-guard has already written any
 * provider selection the student staged on the way in, so there is no browser state to consult
 * (LA-22939).
 *
 * Shared by the entry guard, which redirects before the flow activates, and by
 * ApplicationComponent, which moves the student on as each step is saved. Keeping one copy is
 * what stops those two disagreeing about where someone belongs.
 */
export function nextApplicationPage(
    application: Application | undefined
): string {
    // If the application was successfully submitted, show the submitted confirmation page.
    if (application?.isSubmitted)
        return `${runtimeConfig.clientCode}/application-submitted`;

    // Otherwise, route through the incomplete sections based on completion flags.
    // Note: if isDisclosureComplete=true but isSubmitted=false, keep user on disclosure page
    // (a rare stuck state) rather than showing a false "confirmed" page.
    if (application?.isEducationComplete)
        return `${runtimeConfig.clientCode}/application/disclosure`;
    else if (application?.isBackgroundComplete)
        return `${runtimeConfig.clientCode}/application/your-education`;
    else if (application?.isPersonalInfoComplete)
        return `${runtimeConfig.clientCode}/application/background`;
    else if (
        application?.selectedProviderIds &&
        application.selectedProviderIds.length > 0
    )
        return `${runtimeConfig.clientCode}/application/personal-information`;
    else return `${runtimeConfig.clientCode}/provider`;
}
